const funneldata = [
  {
    id: "step_sent",
    value: 69425,
    label: "Sent",
  },
  {
    id: "step_viewed",
    value: 49892,
    label: "Viewed",
  },
  {
    id: "step_clicked",
    value: 40019,
    label: "Clicked",
  },
  {
    id: "step_add_to_card",
    value: 30243,
    label: "Add To Card",
  },
  {
    id: "step_purchased",
    value: 20993,
    label: "Purchased",
  },
];
export default funneldata;